import { useEffect, useState } from "react"
import getUrl from "../tools/get-domain"


export default function StrategyListPage(props) {
    const [rowData, setRowData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const [search, setSearch] = useState('')
    const [contract, setContract] = useState('all')
    const [future, setFuture] = useState('all')
    const [profit, setProfit] = useState('all')
    const [loss, setLoss] = useState('all')
    const [level, setLevel] = useState('all')

    const filterredData = rowData
        .filter((row) => search === '' || row.title.toLowerCase().includes(search.toLocaleLowerCase()))
        .filter((row) => contract === 'all' || row.contract === contract)
        .filter((row) => future === 'all' || row.future_status === future)
        .filter((row) => profit === 'all' || row.profit === profit)
        .filter((row) => loss === 'all' || row.loss === loss)
        .filter((row) => level === 'all' || row.level === level)


    const fetchData = async () => {
        setIsLoading(true)
        const url = `${getUrl().REACT_APP_STRATEGY}?data=True`

        const response = await fetch(url)
        const data = await response.json()

        if (data && 'object_list' in data) {
            setRowData(data.object_list)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const showFutureStatus = (row) => {
        if (row.future_status === 'ascending') {
            return 'صعودی'
        } else if (row.future_status === 'descending') {
            return 'نزولی'
        } else if (row.future_status === 'inside') {
            return 'داخل کانال'
        } else if (row.future_status === 'suspicious') {
            return 'صعودی مشکوک'
        } else if (row.future_status === 'outside') {
            return 'خارج کانال'
        }
    }

    const renderedTr = rowData.length > 0 ?
        filterredData.map((row, index) => {
            return (
                <tr
                    key={row.id}
                    className="even:tw-bg-gray-100 table-row tw-text-center"
                >
                    <td className="tw-px-6 tw-py-4">{index + 1}</td>
                    <td className="tw-px-6 tw-py-4">
                        <a
                            href={`/اختیار_معامله/strategy/${row.slug}`}
                            target="_blank"
                            className="tw-text-gray-700"
                            rel="noreferrer"
                        >
                            {row.title}
                        </a>
                    </td>
                    <td className="tw-px-6 tw-py-4">{showFutureStatus(row)}</td>
                    <td className="tw-px-6 tw-py-4">{row.contract === 'buy' ? 'call' : row.contract === 'sell' ? 'put' : 'هردو'}</td>
                    <td className="tw-px-6 tw-py-4">{row.profit === 'limit' ? 'محدود' : 'نامحدود'}</td>
                    <td className="tw-px-6 tw-py-4">{row.loss === 'limit' ? 'محدود' : 'نامحدود'}</td>
                    <td className="tw-px-6 tw-py-4">{row.level === 'professional' ? 'حرفه ای' : 'متوسط'}</td>
                    <td className="tw-px-6 tw-py-4">{!row.is_freemium ? 'آزاد' : 'فقط اعضا'}</td>
                </tr>
            )
        }) :
        <tr></tr>

    return (
        <>
            {!isLoading ?
                <>
                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-6 tw-gap-2 tw-bg-white p-2 tw-border tw-rounded">
                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">جستجو استراتژی</label>
                                    <input
                                        onChange={(e) => setSearch(e.target.value)}
                                        value={search}
                                        type="search"
                                        name="search"
                                        className="form-control"
                                        placeholder="جستجو ..." />
                                </div>


                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">نوع قرارداد</label>
                                    <select
                                        id="contract_filter"
                                        className="form-select"
                                        onChange={(e) => setContract(e.target.value)}>
                                        <option value="all" selected="">همه</option>
                                        <option value="sell">put</option>
                                        <option value="buy">call</option>
                                    </select>
                                </div>

                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">وضعیت آینده</label>
                                    <select
                                        onChange={(e) => setFuture(e.target.value)}
                                        id="future_status_filter"
                                        className="form-select"
                                    >
                                        <option value="all" selected="">همه</option>
                                        <option value="inside">داخل کانال</option>
                                        <option value="outside">خارج کانال</option>
                                        <option value="ascending">صعودی</option>
                                        <option value="descending">نزولی</option>
                                        <option value="suspicious">صعودی مشکوک</option>
                                    </select>
                                </div>

                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">سود</label>
                                    <select
                                        onChange={(e) => setProfit(e.target.value)}
                                        id="profit_filter"
                                        className="form-select" aria-label="Disabled select example">
                                        <option value="all" selected=""> همه</option>
                                        <option value="limit">محدود</option>
                                        <option value="unlimit">نامحدود</option>
                                    </select>
                                </div>

                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">زیان</label>
                                    <select
                                        onChange={(e) => setLoss(e.target.value)}
                                        id="loss_filter"
                                        className="form-select" aria-label="Disabled select example">
                                        <option value="all" selected=""> همه</option>
                                        <option value="limit">محدود</option>
                                        <option value="unlimit">نامحدود</option>
                                    </select>
                                </div>

                                <div className="tw-flex tw-flex-col tw-gap-1">
                                    <label htmlFor="" className="tw-text-sm">سطح</label>
                                    <select
                                        onChange={(e) => setLevel(e.target.value)}
                                        id="level_filter"
                                        className="form-select" aria-label="Disabled select example">
                                        <option value="all" selected="">همه</option>
                                        <option value="beginner">متوسط</option>
                                        <option value="professional">حرفه ای</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="tw-w-full tw-relative tw-overflow-x-auto tw-bg-white tw-rounded-xl tw-border">
                                <table className="tw-min-w-full tw-divide-y tw-divide-gray-200">
                                    <thead className="tw-text-center">
                                        <tr className="tw-bg-blue-600 tw-text-white">
                                            <th className="tw-px-6 tw-py-4">ردیف</th>
                                            <th className="tw-px-6 tw-py-4">نام استراتژی</th>
                                            <th className="tw-px-6 tw-py-4">وضعیت آینده</th>
                                            <th className="tw-px-6 tw-py-4">قرارداد</th>
                                            <th className="tw-px-6 tw-py-4">سود</th>
                                            <th className="tw-px-6 tw-py-4">زیان</th>
                                            <th className="tw-px-6 tw-py-4">سطح</th>
                                            <th>دسترسی</th>
                                        </tr>
                                    </thead>
                                    <tbody>{renderedTr}</tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
                :
                <div>لطفا منتظر بمانید</div>
            }
        </>
    )
}